const APPLE_PLATFORM_PATTERN = /macOS|Mac|iPhone|iPad|iPod/i;

type NavigatorWithUserAgentData = Navigator & {
  userAgentData?: {
    platform?: string;
  };
};

function getNavigatorPlatform() {
  if (typeof navigator === 'undefined') {
    return '';
  }

  return (
    (navigator as NavigatorWithUserAgentData).userAgentData?.platform ?? ''
  );
}

export function isApplePlatform(
  platform = getNavigatorPlatform(),
  userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent,
  maxTouchPoints = typeof navigator === 'undefined'
    ? 0
    : navigator.maxTouchPoints,
) {
  return (
    APPLE_PLATFORM_PATTERN.test(platform) ||
    (platform === 'MacIntel' && maxTouchPoints > 1) ||
    /\biPad\b/i.test(userAgent)
  );
}

export function getPrimaryModifierKeyLabel() {
  return isApplePlatform() ? '\u2318' : 'Ctrl';
}

export function getTimeTrackerShortcutLabel() {
  return `${getPrimaryModifierKeyLabel()} Space`;
}

export function getKeyboardShortcutLabel(key: string) {
  return `${getPrimaryModifierKeyLabel()} ${key}`;
}
